import { colors } from '@lmc/common/constants'
import { ListItem } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Icon, ProfilePicture } from '../../../../components/generic'
import { history } from '../../../../store'
import type { ResidentEntry } from '../../utils/stockAlertsTypes'

type Props = {
  resident: ResidentEntry
}

const ResidentStockItem = ({ resident }: Props) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const allAlerts = [
    ...(resident.outOfStock || []),
    ...(resident.lowStock || [])
  ]

  if (!allAlerts.length || !resident?.name) return null

  const chosenName = resident.preferredName || resident.name.first || ''
  const name = `${chosenName} ${resident.name.last || ''}`.trim()

  const handleClick = () => {
    history.push(`/residents/${resident.id}/emar/stock`)
  }

  return (
    <ListItem
      iconContent={
        <ProfilePicture
          url={resident.picture}
          style={profilePictureStyle}
          type="small"
        />
      }
      iconBackgroundColor="transparent"
      titleContent={name}
      subTitleContent={
        <MedList>
          {resident.outOfStock?.map((med) => (
            <MedRow key={med.patternId}>
              <AlertText>{t('OUT_OF_STOCK_LABEL')}</AlertText> &bull;{' '}
              {med.medicationName}
            </MedRow>
          ))}
          {resident.lowStock?.map((med) => (
            <MedRow key={med.patternId}>
              <AlertText>
                {t('LOW_STOCK_LEFT_LABEL', { count: med.currentStock })}
              </AlertText>{' '}
              &bull; {med.medicationName}
            </MedRow>
          ))}
        </MedList>
      }
      subtitleStyle={{ color: colors.darkgrey }}
      rightChildren={
        <RightContent>
          <AlertCount>{allAlerts.length}</AlertCount>
          <Icon fill={colors.red} name="incident" size={24} />
        </RightContent>
      }
      onClick={handleClick}
      cursor="pointer"
    />
  )
}

const profilePictureStyle = {
  border: 'none',
  width: 38,
  height: 38,
  borderRadius: '50%'
}

const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const MedList = styled.div`
  display: flex;
  flex-direction: column;
`

const MedRow = styled.div`
  color: ${colors.darkgrey};
`

const AlertText = styled.span`
  color: ${colors.red};
`

const AlertCount = styled.span`
  color: ${colors.red};
  line-height: 22px;
`

export default ResidentStockItem
